import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Quote_Start from "../assets/quote_start.svg";
import Logo from "../assets/DCG_sticker_01_black_bg.png";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#009BB5",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#0E8064',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '40px 28px',

        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },

        '& a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        },

        [theme.breakpoints.up('md')]: {
            width: '770px',
            flexDirection: 'row',
        }
    },
    icon: {
        padding: '0 0 15px 0',

        [theme.breakpoints.up('md')]: {
            padding: '10px 15px 0 0',
        }
    },
    title: {
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    host: {
        padding: '15px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',
    },
    listen: {
        padding: '20px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',

        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },

        '& a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        },
    },
    logo: {
        '& img': {
            width: '190px',
        },

        [theme.breakpoints.up('md')]: {
            padding: '60px 0 0 30px',
        }
    }
});

class TermsPanel extends React.PureComponent {
    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.icon}><img src={Quote_Start} alt={"Quote"} /></div>

                        <div className={classes.podcastContent}>
                            <div className={classes.title}>Dragon Community Gym Terms and Conditions</div>
                            <div className={classes.host}></div>
                            <div className={classes.description}>
                                <ol>
                                    <li>Dragon Community Gym operates on a weekly subscription, which you may cancel at any time. Cancelling a subscription requires 2 weeks written notice by <a href="mailto:matt@dragoncommunitygym.com">email</a>.</li>
                                    <li>Personal training sessions that are not rescheduled or cancelled 24 hours in advance may result in that session being forfeited.</li>
                                    <li>If arriving late then you will receive the remaining scheduled session time, unless other arrangements have been made.</li>
                                    <li>Training sessions must be completed within 6 months from date of payment. Sessions are void after that time.</li>
                                </ol>

                            </div>
                        </div>

                        <div className={classes.logo}><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/matt-allbeury/"><img src={Logo} alt={"Logo"} /></a></div>

                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(TermsPanel)